module.exports = __webpack_public_path__ + "static/media/up-arrow.64c2e6f4.svg";